var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowCircleAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 7,
    fill: "#F2B90D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52538 3.493V6.067C7.52538 6.34 7.51188 6.6085 7.48488 6.8725C7.45788 7.1335 7.42338 7.411 7.38138 7.705H6.62538C6.58338 7.411 6.54888 7.1335 6.52188 6.8725C6.49488 6.6085 6.48138 6.34 6.48138 6.067V3.493H7.52538ZM6.30588 9.388C6.30588 9.295 6.32238 9.2065 6.35538 9.1225C6.39138 9.0385 6.43938 8.9665 6.49938 8.9065C6.56238 8.8465 6.63588 8.7985 6.71988 8.7625C6.80388 8.7265 6.89388 8.7085 6.98988 8.7085C7.08288 8.7085 7.17138 8.7265 7.25538 8.7625C7.33938 8.7985 7.41138 8.8465 7.47138 8.9065C7.53438 8.9665 7.58388 9.0385 7.61988 9.1225C7.65588 9.2065 7.67388 9.295 7.67388 9.388C7.67388 9.484 7.65588 9.574 7.61988 9.658C7.58388 9.739 7.53438 9.8095 7.47138 9.8695C7.41138 9.9295 7.33938 9.976 7.25538 10.009C7.17138 10.045 7.08288 10.063 6.98988 10.063C6.89388 10.063 6.80388 10.045 6.71988 10.009C6.63588 9.976 6.56238 9.9295 6.49938 9.8695C6.43938 9.8095 6.39138 9.739 6.35538 9.658C6.32238 9.574 6.30588 9.484 6.30588 9.388Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCircleAlert);
export default __webpack_public_path__ + "static/media/yellowCircleAlert.fe1cfe926788be358fa64a9878cb7cdd.svg";
export { ForwardRef as ReactComponent };